import { __makeTemplateObject } from "tslib";
import { styled } from "styled-components";
export var GridAreaContainer = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: grid;\n  grid-template-columns: repeat(", ", 1fr);\n  gap: ", ";\n"], ["\n  display: grid;\n  grid-template-columns: repeat(", ", 1fr);\n  gap: ", ";\n"])), function (_a) {
    var colCount = _a.colCount;
    return colCount;
}, function (_a) {
    var gap = _a.gap;
    return gap;
});
var templateObject_1;
//# sourceMappingURL=styles.js.map